import showToastNotification from '@/hooks/useShowToast'
import { trpc } from '@/utils/trpc'
import { useSwitchAccount } from './useSwitchAccount'

export const useLeaveTeam = (onClose: () => void) => {
  const { switchAccount } = useSwitchAccount()
  const utils = trpc.useUtils()
  const { mutate: leaveTeam, isPending: isLeavingTeam } = trpc.leaveTeam.useMutation({
    onSuccess: async () => {
      showToastNotification('success', {
        message: 'Left Team',
        description: 'You have successfully left the team.',
      })
      onClose()
      switchAccount({ teamId: undefined })
      await utils.getTeamMembers.invalidate()
    },
    onError: () => {
      showToastNotification('error', {
        message: 'Failed to Leave Team',
        description: "We couldn't process your request. Please try again later.",
      })
    },
  })

  return { leaveTeam, isLeavingTeam }
}
